import React, { useEffect, useState } from "react";
import CommonPopup from "..";
import { patchEvacueeStatus } from "../../../services/managerEmergencyServices";
import { EvacuationStatusType } from "../../../types/emergency";

interface EmergencyCheckPopupProps {
  company: string;
  name: string;
  evacuationEvacueeMapUuid: string;
  currentStatus: EvacuationStatusType;
  onClose: () => void;
  onConfirm: () => void; // 확인 버튼 클릭 시 호출할 함수
  isOpenProps: string;
}

export default function EmergencyCheckPopup({
  company,
  name,
  evacuationEvacueeMapUuid,
  currentStatus,
  onClose,
  onConfirm,
  isOpenProps,
}: EmergencyCheckPopupProps) {
  const [isOpen, setIsOpen] = useState(isOpenProps);
  const [status, setStatus] = useState<EvacuationStatusType>(currentStatus); // 초기화가 크게 의미 없는 구조...

  const handleClose = () => {
    setIsOpen("");
    onClose();
  };

  useEffect(() => {
    setIsOpen(isOpenProps);
    if (isOpenProps === "statusChange") {
      // 열릴때 항상 props 를 state 에 반영
      setStatus(currentStatus);
    }
  }, [isOpenProps]);

  const handleConfirm = async () => {
    try {
      await patchEvacueeStatus(evacuationEvacueeMapUuid, { status });
      onConfirm();
    } catch (error) {
      console.error("상태 변경 중 오류 발생:", error);
    }
  };

  return (
    <CommonPopup
      isOpen={isOpen === "statusChange"}
      onClose={handleClose}
      padding={6}
    >
      <div className="flex flex-col items-center justify-center space-y-4">
        <div className="flex flex-col pt-6 items-center">
          <div className="flex flex-row">
            <div className="font-semibold">{`${company} ${name}`}</div>
            <div>님의</div>
          </div>
          {`상태를 변경하시겠습니까?`}
        </div>
        <div className="w-full">
          <select
            className="w-full p-2 border border-gray-300 rounded-md"
            value={status}
            onChange={(e) => setStatus(e.target.value as EvacuationStatusType)}
          >
            <option value="CREATED_NO_RESPONSE">무응답</option>
            <option value="EVACUATION_COMPLETE">대피완료</option>
            <option value="ON_LEAVE_OR_OUT">휴가/외근</option>
            <option value="HELP_ME">구조요청</option>
          </select>
        </div>
        <div className="w-full flex justify-between">
          <button
            className="w-full py-3 bg-gray-300 text-black rounded-md mr-2"
            onClick={handleClose}
          >
            취소
          </button>
          <button
            className="w-full py-3 bg-pink-500 text-white rounded-md ml-2"
            onClick={handleConfirm} // 확인 버튼 클릭 시 API 호출 및 부모 상태 갱신
          >
            확인
          </button>
        </div>
      </div>
    </CommonPopup>
  );
}
